import {
  animate,
  AnimationBuilder,
  AnimationFactory,
  AnimationPlayer,
  style,
} from "@angular/animations";
import {
  AfterViewInit,
  Component,
  ContentChildren,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from "@angular/core";

@Directive({
  selector: "[brandCampaignContentCalendarPostsCarouselItem]",
})
export class BrandCampaignContentCalendarPostsCarouselItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  selector: ".brand-campaign-content-calendar-posts-carousel-item",
})
export class BrandCampaignContentCalendarPostsCarouselItemElementDirective {}

@Component({
  selector: "app-brand-campaign-content-calendar-posts-carousel",
  templateUrl:
    "./brand-campaign-content-calendar-posts-carousel.component.html",
  styleUrl: "./brand-campaign-content-calendar-posts-carousel.component.scss",
})
export class BrandCampaignContentCalendarPostsCarouselComponent
  implements AfterViewInit
{
  @Output() public currentItem = new EventEmitter<number>();

  @ContentChildren(BrandCampaignContentCalendarPostsCarouselItemDirective)
  protected items!: QueryList<BrandCampaignContentCalendarPostsCarouselItemDirective>;

  @ViewChild("carousel") private carousel!: ElementRef;

  private player?: AnimationPlayer;
  private itemWidth?: number;

  protected currentSlide = 0;
  protected carouselWrapperStyle: Record<string, any> = {};

  constructor(private readonly builder: AnimationBuilder) {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.itemWidth = 510;
      this.carouselWrapperStyle = { width: "100%" };
    });
  }

  protected next(): void {
    if (this.currentSlide + 1 === this.items.length) {
      return;
    }

    this.currentSlide = (this.currentSlide + 1) % this.items.length;
    this.currentItem.emit(this.currentSlide);
    const offset = this.currentSlide * this.itemWidth!;

    this.player = this.buildAnimation(offset).create(
      this.carousel.nativeElement,
    );
    this.player.play();
  }

  private buildAnimation(offset: number): AnimationFactory {
    return this.builder.build([
      animate(
        "350ms ease-in-out",
        style({ transform: `translateX(-${offset}px)` }),
      ),
    ]);
  }

  protected prev(): void {
    if (this.currentSlide === 0) {
      return;
    }

    this.currentSlide =
      (this.currentSlide - 1 + this.items.length) % this.items.length;
    this.currentItem.emit(this.currentSlide);
    const offset = this.currentSlide * this.itemWidth!;

    this.player = this.buildAnimation(offset).create(
      this.carousel.nativeElement,
    );
    this.player.play();
  }
}
